import { render } from "./ParameterView.vue?vue&type=template&id=457d7f50&scoped=true"
import script from "./ParameterView.vue?vue&type=script&lang=js"
export * from "./ParameterView.vue?vue&type=script&lang=js"

import "./ParameterView.vue?vue&type=style&index=0&id=457d7f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457d7f50"]])

export default __exports__